import React from "react"
import { Grid } from "@mui/material"
import { SwitchCSV } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import ReportFormDrawerDateSection from "./DateSection"
import ReportFormDrawerCsvSection from "./CsvSection"
import ReportFormSectionDivider from "Pages/ReportsAlerts/Reports/@components/FormDrawer/SectionDivider"


export default function ReportFormDrawerSearchConfigSection() {


	return <Grid container spacing={2}>
		<Grid item xs={2}>
			<ReportFormSectionDivider title="Search Configuration" icon="magnifying-glass"/>
		</Grid>
		<Grid item xs={3} data-tour-id="tour-csv-switch">
			<SwitchCSV/>
		</Grid>
		<Grid item xs={7}/>
		<Grid item xs={12}>
			<SearchConfigurationSubSection/>
		</Grid>
	</Grid>
}

function SearchConfigurationSubSection() {

	return useCsv.value ? <ReportFormDrawerCsvSection/> : <ReportFormDrawerDateSection/>
}